/**
 * partner-editor API — a partner/02-03 admin-szerkesztő kliens (D0 frozen seam #357 `85f64aae`).
 *
 * A `PartnerEditorReadSchema` (Zod) RUNTIME-validálja a GET-választ → a mock-first FE a
 * pinnelt kontraktushoz illeszkedik (seam-drift azonnal kiderül). A PATCH a
 * `PartnerEditorPatchSchema`-val validál KÜLDÉS ELŐTT — így a 2 gotcha client-side dől el:
 *   - NAGYBETŰS `type` (a kisbetűs READ-érték nem küldhető vissza nyersen — #352-osztály)
 *   - `isoDate` (YYYY-MM-DD) — a full-ISO 400-azna a BE szigorúbb validációján (Zeno #358)
 *   - idCard nyers/üres=megtart (GDPR — a READ sosem adja vissza nyersen)
 *
 * Wire (valós BE, PR #358 controller): GET/PATCH `/api/v1/partners-direct/:id`.
 * READ a real `/partners-direct/:id`-en megy — a #358 controller editor-shape superset-et
 * szolgál (a régi PartnerDetailPage subset-jét is fedi). A mock id-gated superset-handlerrel
 * tükrözi ezt (fall-through a régi handlerre nem-fixture id-knál).
 */
import {
  PartnerEditorPatchSchema,
  PartnerEditorReadSchema,
  type PartnerEditorPatch,
  type PartnerEditorRead,
} from '@kgc/partners/partner-editor';
import { z } from 'zod';

import { api } from './client';

const PartnerEditorReadEnvelope = z.object({ data: PartnerEditorReadSchema });

/** GET read-view — runtime seam-validáció a pinnelt Zod-kontraktusra. */
export async function getPartnerEditor(id: string): Promise<PartnerEditorRead> {
  const raw = await api.get<unknown>(`/partners-direct/${id}`);
  return PartnerEditorReadEnvelope.parse(raw).data;
}

/** PATCH mező-szerkesztés — KÜLDÉS ELŐTT validál a frozen PATCH-kontraktusra. */
export async function updatePartnerEditor(
  id: string,
  patch: PartnerEditorPatch
): Promise<PartnerEditorRead> {
  const body = PartnerEditorPatchSchema.parse(patch);
  const raw = await api.patch<unknown>(`/partners-direct/${id}`, body);
  return PartnerEditorReadEnvelope.parse(raw).data;
}
